export default "__VITE_ASSET__dda0675f__"